import React from "react";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Label from "./label";
import { cn } from "../../utility/utils";

const DateInput = ({
  className,
  label = "label",
  rules,
  name,
  control,
  maxDate,
  onChangeFn,
  onChangeRaw,
  onCalendarClose,
  onBlur,
  placeholderText,
  value,
  onChange,
  error,
  ...props
}) => {
  const getConvertedValue = (value) => {
    if (!value) return null;

    if (value instanceof Date) {
      return value;
    }

    const timestamp = Number(value);
    if (!isNaN(timestamp)) {
      return timestamp > 9999999999 ? new Date(timestamp) : new Date(timestamp * 1000);
    }

    const parsedDate = new Date(value);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate;
    }

    return null;
  };

  const renderDatePicker = (val, onChg, err) => (
    <div className="flex flex-col space-y-2">
      {label && (
        <Label>
          {label}
          {rules?.required && <span className="text-red-600">*</span>}
        </Label>
      )}
      <div>
        <DatePicker
          selected={getConvertedValue(val)}
          onChange={(date) => {
            onChg(date);
            onChangeFn?.(date);
          }}
          onBlur={onBlur}
          onChangeRaw={onChangeRaw}
          onCalendarClose={onCalendarClose}
          maxDate={maxDate}
          placeholderText={placeholderText}
          dateFormat="dd/MM/yyyy"
          className={cn(
            "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
          autoComplete="off"
          {...props}
        />
      </div>
      {err && (
        <small className="text-red-600 font-medium block pt-1 text-sm">
          {err.message || err}
        </small>
      )}
    </div>
  );

  if (control && name) {
    return (
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { value: fValue, onChange: fOnChange }, fieldState: { error: fError } }) =>
          renderDatePicker(fValue, fOnChange, fError)
        }
      />
    );
  }

  return renderDatePicker(value, onChange, error);
};

export default DateInput;
